/** @jsx jsx */
import { CRow, CSpinner } from "@coreui/react"
import { jsx } from "@emotion/react"
import { is } from "core-js/core/object"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import CMSCard from "../cards/CMSCards"


export default function SpinnerCard({
  title,
  noHeader = false,
  description
}) {

  const projectID = useSelector((state) => {
    return state.settings.currentProject
  })

  const isPHSorCargill = projectID === "PROJ0040466" || projectID === "PROJ0040017"

  const [showDescription, setShowDescription] = useState(false)

  useEffect(() => {
    if (description) {
      const timer = setTimeout(() => {
        setShowDescription(true)
      }, 10000)
      return () => clearTimeout(timer)
    } else if (isPHSorCargill) {
      const timer = setTimeout(() => {
        setShowDescription(true)
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [description, isPHSorCargill])

  return (
    <CMSCard>
      {noHeader || !title ? (
        ""
      ) : (
        <div>
          <h2 className="h6 m-0 p-0 font-weight-bold">{title}</h2>
        </div>
      )}
      <CRow className="d-flex flex-column justify-content-center align-items-center h-100 text-color">
        <CSpinner className="m-4" style={{ width: "4rem", height: "4rem" }} />
        {description && showDescription && (
          <div className="text-center mb-2">
            <h2 className="h6 m-0 p-0 font-weight-bold">{description}</h2>
          </div>
        )}
        {isPHSorCargill && !description && showDescription && (
          <div className="text-center mb-2">
            <h2 className="h6 m-0 p-0 font-weight-bold">
              Large dataset can take longer time to load
            </h2>
          </div>
        )}
      </CRow>
    </CMSCard>
  )
}

SpinnerCard.propTypes = {
  title: PropTypes.string,
  noHeader: PropTypes.bool,
  description: PropTypes.string
}
